export const ALERT_SUCCESS = 'ALERT:SUCCESS';
export const ALERT_ERROR = 'ALERT:ERROR';
export const ALERT_CLEAR = 'ALERT:CLEAR';